import { useReducer } from 'react';
function useToggle(initialState = false) {
    return useReducer(state => !state, initialState);
}
export default useToggle;
//# sourceMappingURL=useToggle.js.map